/* eslint-disable */
import { h, Component } from 'preact';

class IconArrowRight extends Component {
    render() {
        const { width = 6, height = 8 } = this.props;

        return (
            <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1 0l4 4-4 4"
                    stroke="#333"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }
}

export default IconArrowRight;
